<template>
  <div class="ele-dialog">
    <el-dialog :modal-append-to-body="false" v-bind="$attrs" v-on="$listeners">
      <slot slot="title" name="title"></slot>
      <slot></slot>
      <slot slot="footer" name="footer"></slot>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'EleDialog',
};
</script>

<style lang="less" scoped>
.ele-dialog {
  .v-model {
    background: rgba(17, 17, 17, 0.3);
  }

  .el-dialog__wrapper {
  }

  /deep/ .el-dialog {
    width: 1184px;
    height: 796px;
    background: rgba(20, 26, 38, 0.9);
    /*background: linear-gradient(90deg, rgba(38, 104, 162, 0.2), rgba(0, 0, 0, 0));*/
    border: 2px solid;
    border-image: linear-gradient(90deg, rgba(255, 255, 255, 0.12), rgba(170, 240, 250, 0.12)) 2 2;
    position: relative;
    z-index: -1;
    display: flex;
    flex-direction: column;

    &::before {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, rgba(0, 0, 0, 0), rgba(38, 104, 162, 0.2), rgba(0, 0, 0, 0));
      position: absolute;
      z-index: -1;
    }

    .el-dialog__header {
      height: 55px;
      /*background: linear-gradient(90deg, rgba(71, 166, 249, 0.34));*/
      background: linear-gradient(90deg, rgba(15, 95, 165, 0.45), rgba(0, 0, 0, 0.1));
      border-radius: 3px 3px 0 0;
      padding: 0;
      .flex-center();
      justify-content: flex-start;

      &::before {
        content: '';
        display: inline-block;
        width: 29px;
        height: 55px;
        background: url('~img/home/chart-box-title-icon.png') no-repeat;
        background-size: 100% 100%;
      }
    }

    .el-dialog__title {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-style: italic;
      color: #ffffff;
      text-shadow: 0px 4px 5px rgba(6, 27, 42, 0.65);
      margin-left: 14px;
    }

    .el-dialog__body {
      height: calc(100% - 105px);
      padding: 40px 50px;
      display: flex;
      flex-direction: column;
      flex: 1;
    }
  }
}
</style>
